import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-policy-status',
  templateUrl: './policy-status.component.html',
  styleUrls: ['./policy-status.component.scss'],
})
export class PolicyStatusComponent {
  @Input() status: string = '';
  constructor() { }

 

}
